/**
 * antd 의 disabled 글자색(rgba(0,0,0,0.25))이 너무 흐려 읽기 어려우므로 덮어쓴다.
 * suffix 가 있는 Input(Password 등)은 className 이 wrapper 에 붙으므로 안쪽 input 까지 함께 지정한다.
 */
export const DISABLED_TEXT_CLASS = '!text-gray7 [&_.ant-input]:!text-gray7';
